import React from 'react';
import propTypes from 'prop-types';
import _ from 'lodash';
import { Stack } from '@mui/material';
import OutputActivationThresholdField, { schema as FieldSchema} from './OutputActivationThresholdField';
import * as Yup from 'yup';

export const schema = Yup.object({
  th: FieldSchema,
});
export const TYPE = 'oat';
export const defaultValue = {
  th: 0,
};

export default function OutputActivationThreshold({ namespace, ...props }) {
  return (
    <Stack spacing={2}>
      <OutputActivationThresholdField namespace={namespace + '.th'} label='Threshold' />
    </Stack>
  )
}

OutputActivationThreshold.propTypes = {
  namespace: propTypes.string,
}
